export default "__VITE_ASSET__CPXaeqfQ__"